import React, { useState } from 'react';
import { Text, Flex } from '@badi/badi-components';
import Select from 'components/Form/Select/Select';
import { translate } from 'base/shared/Localization';
import { COUPLE } from 'base/shared/StaticData';
import { SearchLengthStayWrapper } from '../styled-components';

const WhoIsMovingSelector = ({ id = '', onChange = () => {}, initialValue = 1, grow = 0 }) => {
  const coupleOptions = translate(COUPLE, ['title']);

  const [value, setValue] = useState(initialValue);

  const handleWhoIsMovingChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    setValue(selectedValue);
    onChange(selectedValue);
  };

  return (
    <Flex dataQa="search-bar-who-is-moving-selector" direction="column" grow={grow}>
      <label htmlFor="who-is-moving-selector">
        <Text body="12-Medium">{translate('user.section.who_is_moving')}</Text>
        <SearchLengthStayWrapper
          name={'search-bar-who-is-moving-select'}
          onChange={handleWhoIsMovingChange}
          required={true}
          value={value}
        >
          <option disabled={true} value={''}>
            {translate('user.section.who_is_moving')}
          </option>

          {coupleOptions.map(({ title, value: itemVal }) => (
            <option key={`${title}-${itemVal}`} value={itemVal.toString()}>
              {title}
            </option>
          ))}
        </SearchLengthStayWrapper>
      </label>
    </Flex>
  );
};

export default WhoIsMovingSelector;
